











































import { Component, Vue } from 'vue-property-decorator'
import ErrorFormResponse from '../../modules/class/ErrorFormResponse'
import Download from '../../components/Membership/Download/Download.vue'

@Component({
  components: {
    Download
  }
})
export default class CallDownloadLink extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // Props

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private resultError: ErrorFormResponse = {}
  private haserror = false

  // -------------------------------------------------------------------------------------------------------------------
  // hocks

  private created() {
    // エラーメッセージの初期化
    this.clearError()
  }

  private mounted() {
    // 野良リンクにイベント追加
    this.setEventForHTMLElements()
    // membership外でPDFダウンロードを行うためのカスタムイベント追加
    this.setEventForOutsideMembershipControll()
  }

  // -------------------------------------------------------------------------------------------------------------------
  // Computed

  get download(): Download {
    return this.$refs.download as Download
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * Drupalで出力されているaタグ要素にクリックイベントを追加し、
   * クリックされたときにVueで定義しているDownload処理を呼び出す
   */
  private setEventForHTMLElements() {
    const nodeList = document.querySelectorAll('.js-downloadLink')
    if (nodeList.length > 0) {
      nodeList.forEach((node) => {
        const href = node.getAttribute('href') ?? ''
        const url = this.convetUrl(href)

        // クリックイベントを登録
        node.addEventListener(
          'click',
          (e) => {
            e.preventDefault()

            // setTimeoutしないとDownloadLinkコンポーネントが undefined として処理される
            setTimeout(() => {
              this.redirect(url)
            }, 100)
          },
          false
        )
      })
    }
  }

  /**
   * カスタムイベントを追加し、
   * membershipcontroll外の処理からイベントコールされたときに
   * DownloadLinkのselectUrlを呼び出す
   */
  private setEventForOutsideMembershipControll() {
    document.addEventListener(
      'start-pdf-download',
      (event: CustomEventInit<{ url: string }>) => {
        if (event.detail !== undefined) {
          const url = this.convetUrl(event.detail.url ?? '')
          // setTimeoutしないとDownloadLinkコンポーネントが undefined として処理される
          setTimeout(() => {
            this.redirect(url)
          }, 100)
        }
      }
    )

    // イベントを定義したことを宣言
    window.iwgp.existDlEvent = true
  }

  /**
   * 各リンクに応じたリダイレクト処理を行う
   */
  private redirect(url: URL) {
    this.download.start(url)
  }

  /**
   * ドメイン付きのURLに変換する
   */
  private convetUrl(url: string): URL {
    if (!url.match(/^https?:/)) {
      url = document.location.protocol + '//' + document.location.host + url
    }
    return new URL(url)
  }

  /**
   * download url clickにて発生したエラーをDownladLinkコンポーネントから受け取る
   */
  private setError(error: ErrorFormResponse) {
    this.resultError = error
    this.haserror = true
  }

  /**
   * download url clickにて発生したエラーを初期化する
   */
  private clearError() {
    this.resultError = {}
    this.haserror = false
  }
}
